import withScroll from '../hoc/withScroll'

export default withScroll({
  name: 'animated-txt',

  componentDidMount () {

  },

  onScroll ({ y }) {
    if (y + window.innerHeight > this.el.offsetTop && !this.el.classList.contains('animated-text')) {
      this.animateLetters()
      this.el.classList.add('animated-text')
    }
  },

  animateLetters () {
    let text = this.el.dataset.text.split('')
    let textTemp = this.el.textContent.split('')
    let index = 0
    let interval
    interval = setInterval(() => {
      if (index === textTemp.length) {
        clearInterval(interval)
      }

      textTemp[index] = text[index]
      this.el.textContent = textTemp.join('')
      index++
    }, 60)
  },
})
